import { MiscInvoiceProcessingPending } from "../MiscInvoiceProcessingPending";
import { MiscInvoiceProcessingReady } from "../MiscInvoiceProcessingReady";
import { DataSource, Layout, LayoutHeader, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceProcessing extends Layout {
    layoutPending: MiscInvoiceProcessingPending;
    layoutReady: MiscInvoiceProcessingReady;
    layoutheaderMiscInvoiceProcessing: LayoutHeader;
    sourceMiscBill: DataSource;
    tabPendingReview: Tab;
    tabReadyToProcess: Tab;
    tabsetMiscInvoiceProcessing: Tabset;
}
